import { Autocomplete } from "@visioni/a3s-ui/components";

interface OrderOption {
  /** As the URL carries it; `undefined` for the default, which writes no param. */
  readonly order: "asc" | undefined;
  readonly label: string;
}

/** A list, not a toggle, so another ordering can join it later. */
const OPTIONS: readonly OrderOption[] = [
  { order: undefined, label: "Newest first" },
  { order: "asc", label: "Oldest first" },
];

const optionId = (o: OrderOption) => o.order ?? "desc";
const optionLabel = (o: OrderOption) => o.label;

interface OrderFieldProps {
  /** As the URL carries it: `asc` is oldest first, and anything else — absent included — newest first. */
  readonly value: string | undefined;
  /** Newest first is written as no `order` at all, so the default keeps a clean link. */
  readonly onChange: (order: "asc" | undefined) => void;
}

/** Which end of the time order a list starts from. */
export function OrderField({ value, onChange }: OrderFieldProps) {
  const selected = OPTIONS.find((o) => o.order === (value === "asc" ? "asc" : undefined)) ?? null;
  return (
    <Autocomplete<OrderOption>
      options={OPTIONS}
      value={selected}
      // Clearing returns to the default rather than leaving no order.
      onChange={(option) => onChange(option?.order)}
      getOptionLabel={optionLabel}
      getOptionId={optionId}
      placeholder="Newest first"
      label="Order"
      floatLabel="always"
    />
  );
}
